import { render, staticRenderFns } from "./OfferItem.vue?vue&type=template&id=76051088&scoped=true&"
import script from "./OfferItem.vue?vue&type=script&lang=js&"
export * from "./OfferItem.vue?vue&type=script&lang=js&"
import style0 from "./OfferItem.vue?vue&type=style&index=0&id=76051088&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76051088",
  null
  
)

export default component.exports